export const PLATFORM_MENU_ICONS_SETTING_KEY = 'platformMenuIcons'

export const EMPTY_PLATFORM_MENU_ICONS = {
  basic: {},
  mobile: {},
}

const isHexColor = (value) =>
  typeof value === 'string' &&
  /^#(?:[0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(value)

const parseSetting = (setting) => {
  if (!setting) return EMPTY_PLATFORM_MENU_ICONS

  try {
    const value = typeof setting === 'string' ? JSON.parse(setting) : setting
    return value && typeof value === 'object'
      ? value
      : EMPTY_PLATFORM_MENU_ICONS
  } catch {
    return EMPTY_PLATFORM_MENU_ICONS
  }
}

const normalizeItems = (items) => {
  if (!items || typeof items !== 'object' || Array.isArray(items)) return {}

  return Object.entries(items).reduce((result, [key, value]) => {
    if (!value || typeof value !== 'object') return result

    const icon = typeof value.icon === 'string' ? value.icon.trim() : ''
    const color = isHexColor(value.color) ? value.color : ''
    if (icon || color) result[key] = { icon, color }

    return result
  }, {})
}

export const parsePlatformMenuIcons = (setting) => {
  const value = parseSetting(setting)

  return {
    basic: normalizeItems(value.basic),
    mobile: normalizeItems(value.mobile),
  }
}

export const getMenuCustomizationKey = (item, type = 'item') => {
  if (item?.id !== null && item?.id !== undefined) return `${type}:${item.id}`
  if (item?.url) return `${type}:url:${item.url}`

  return null
}

export const getMenuIconStyle = (customization) =>
  customization?.color
    ? { '--menu-icon-color': customization.color }
    : undefined
